import { GamificationIconType } from '@bg-components/GamificationIcon';
import { GAMIFICATION_TAB } from '@bg-components/Profile/enums';

export const STORAGE_KEY = 'badge_date_seen';

export const INTRO_PAGE_ORDERED_PRESET = [
    {
        buttonText: 'view_challenges',
        id: GAMIFICATION_TAB.CHALLENGES,
        icon: GamificationIconType.BADGE,
    },
    {
        buttonText: 'view_tournaments',
        id: GAMIFICATION_TAB.TOURNAMENTS,
        icon: GamificationIconType.TOURNAMENT,
    },
    {
        buttonText: 'view_shop',
        id: GAMIFICATION_TAB.SHOP,
        icon: GamificationIconType.SHOP,
    },
    {
        buttonText: 'view_inbox',
        id: GAMIFICATION_TAB.INBOX,
        icon: GamificationIconType.INBOX,
    },
];
export const DATA_REFRESH_INTERVAL = 30000; // 30 seconds
